import React, { createContext, useState, useCallback } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import PropTypes from 'prop-types'; // Import PropTypes
import { Typography, Box } from '@mui/material';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';

export const SnackbarDualLineContext = createContext();

export const SnackbarDualLineProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [snackbarMessageLineOne, setSnackbarMessageLineOne] = useState('');
  const [snackbarMessageLineTwo, setSnackbarMessageLineTwo] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  const openDualLineSnackbar = useCallback((messageLineOne, messageLineTwo, severity = 'info') => {
    setSnackbarMessageLineOne(messageLineOne);
    setSnackbarMessageLineTwo(messageLineTwo);
    setSnackbarSeverity(severity);
    setOpen(true);
  }, []);

  const closeSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  const snackbarMessageLineOneMessage = () => {
    if (snackbarMessageLineOne) {
      return <Typography variant="h4">{snackbarMessageLineOne}</Typography>;
    }
    return <Typography variant="h4">""</Typography>;
  };

  const snackbarMessageLineTwoMessage = () => {
    if (snackbarMessageLineTwo) {
      return <Typography variant="h5">{snackbarMessageLineTwo}</Typography>;
    }
    return <Typography variant="h5">""</Typography>;
  };

  return (
    <SnackbarDualLineContext.Provider value={openDualLineSnackbar}>
      {children}
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={closeSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={closeSnackbar} severity={snackbarSeverity} variant="filled">
          <Box display="flex">
            <Box display="flex" flexDirection="column">
              <Box mb={1}>{snackbarMessageLineOneMessage()}</Box>
              {snackbarMessageLineTwoMessage()}
            </Box>
          </Box>
        </Alert>
      </Snackbar>
    </SnackbarDualLineContext.Provider>
  );
};
SnackbarDualLineProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
